import { html } from '../../mixins/katapult-element';
import { KatapultEditorTemplate } from './katapult-editor-template';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import { DefaultComputedBindings } from '../../modules/DefaultComputedBindings';
import '../katapult-color-picker/katapult-color-picker-button.js';
import '../katapult-color-picker/katapult-color-picker-dialog.js';
import { Path } from '../../modules/Path.js';
import { CamelCase } from '../../modules/CamelCase.js';
import './tags/model-item-tag-selector.js';

export class KatapultPhotoElementEditor extends mixinBehaviors([DefaultComputedBindings], KatapultEditorTemplate) {
  static get template() {
    return html`
      ${super.style}
      <style>
        :host {
          padding: 0;
        }
        .body {
          margin-left: 48px;
        }
        #container {
          display: flex;
          height: 100%;
        }
        #settings {
          width: 800px;
          overflow-y: auto;
          padding: 48px;
        }
        #photo {
          display: flex;
          height: 100%;
          width: 100%;
        }
        #viewer {
          flex-grow: 1;
          height: 100%;
          width: 100%;
        }
        .point {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 8px;
          width: 8px;
          font-size: 0;
          background: var(--paper-grey-400);
          color: white;
          border-radius: 100%;
          flex-shrink: 0;
          transition: all 0.3s;
        }
        #title {
          text-transform: none;
          font-size: 14pt;
          color: var(--paper-grey-600);
          padding-left: 0;
          flex-grow: 0;
          flex-basis: auto;
        }
        .header {
          margin-top: var(--sl-spacing-large);
        }
        katapult-color-picker-button[disabled] {
          pointer-events: none;
        }
      </style>
      <!-- Dialogs -->
      <katapult-color-picker-dialog></katapult-color-picker-dialog>

      <!-- Firebase Workers -->
      <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes" data="{{otherAttributes}}"> </katapult-firebase-worker>

      <!-- Main Content -->
      <div id="container">
        <div id="settings">
          <!-- Edit Photo Element Type -->
          <paper-row header>
            <paper-cell icon>
              <div class="point"></div>
            </paper-cell>
            <paper-cell id="title">Element Type</paper-cell>
          </paper-row>
          <div style="width: 400px; color: var(--primary-text-color-faded); margin-left:48px;">
            <paper-table light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <katapult-drop-down
                    items="[[photoElementTypes]]"
                    value="[[elementType]]"
                    value-path="$key"
                    label-path="label"
                    label="Select an element type"
                    no-label-float
                    data-property="elementType"
                    on-value-changed="photoElementChanged"
                    style="flex: 1; padding: 1em;"
                    disabled="[[!fullyEditable]]"
                  ></katapult-drop-down>
                </paper-cell>
              </paper-row>
            </paper-table>
          </div>
          <!-- Edit Coloring -->
          <paper-row class="header">
            <paper-cell icon>
              <div class="point"></div>
            </paper-cell>
            <paper-cell id="title">Style</paper-cell>
          </paper-row>
          <div style="width: 400px; color: var(--primary-text-color-faded); margin-left:48px;">
            <!-- Background Color -->
            <paper-row>
              <paper-cell>
                <span> Background Color: </span>
              </paper-cell>
              <paper-cell>
                <katapult-color-picker-button
                  data-property="photoElementColor"
                  color="[[photoElementColor]]"
                  on-color-changed="photoElementChanged"
                  disabled$="[[!fullyEditable]]"
                ></katapult-color-picker-button>
              </paper-cell>
            </paper-row>
            <!-- Text Color -->
            <template is="dom-if" if="[[isChip(elementType)]]">
              <paper-row>
                <paper-cell>
                  <span> Text Color: </span>
                </paper-cell>
                <paper-cell>
                  <katapult-color-picker-button
                    data-property="photoElementTextColor"
                    color="[[photoElementTextColor]]"
                    on-color-changed="photoElementChanged"
                    disabled$="[[!fullyEditable]]"
                  ></katapult-color-picker-button>
                </paper-cell>
              </paper-row>
            </template>
          </div>
          <!-- Help Text -->
          <paper-row class="header">
            <paper-cell icon>
              <div class="point"></div>
            </paper-cell>
            <paper-cell id="title">Additional Information</paper-cell>
          </paper-row>
          <div style="width: 400px; color: var(--primary-text-color-faded); margin-left:48px;">
            <paper-textarea
              label="Type any defining text for the photo element here"
              data-property="photoElementHelpText"
              value="[[photoElementHelpText]]"
              on-value-changed="photoElementChanged"
              no-label-float
              disabled="[[!fullyEditable]]"
            ></paper-textarea>
          </div>
          <!-- Allowed Children -->
          <template is="dom-if" if="[[!isChip(elementType)]]">
            <paper-row class="header">
              <paper-cell icon>
                <div class="point"></div>
              </paper-cell>
              <paper-cell id="title">Allowed Children</paper-cell>
            </paper-row>
            <div style="width: 400px; color: var(--primary-text-color-faded); margin-left:48px;">
              <paper-row input light-grey rounded outline>
                <paper-cell>
                  <katapult-multi-drop-down
                    items="[[markerInputModelsForDropDown]]"
                    label-path="$label"
                    value-path="$key"
                    value="[[allowedChildrenForPhotoElement]]"
                    data-property="allowedChildrenForPhotoElement"
                    on-value-changed="multiSelectChanged"
                    display-label
                    no-label-float
                    style="flex: 1; padding: 1em;"
                    disabled="[[!fullyEditable]]"
                  ></katapult-multi-drop-down>
                </paper-cell>
              </paper-row>
            </div>
          </template>
          <paper-row class="header">
            <paper-cell icon>
              <div class="point"></div>
            </paper-cell>
            <paper-cell id="title">Tags</paper-cell>
          </paper-row>
          <div style="width: 400px; margin-left:48px;">
            <paper-table light-grey rounded outline>
              <paper-row input>
                <paper-cell>
                  <model-item-tag-selector
                    style="width: -webkit-fill-available;"
                    model-path="[[modelSpaceDetails.path]]"
                    modelCategory="photo_elements"
                    item-key="[[itemKey]]"
                    tags="[[_itemData.tags]]"
                    on-change="tagSelectorChangeHandler"
                    mayAddTags
                    look-like-paper-element
                  ></model-item-tag-selector>
                </paper-cell>
              </paper-row>
            </paper-table>
          </div>
          ${super.createItemContainer}
        </div>

        <div id="photo">
          <katapult-photo-viewer
            id="viewer"
            src="[[blankPhotoUrl]]"
            photo-data="{{photoData}}"
            annotations
            annotation-editor-show-menu="[[fullyEditable]]"
            annotations-as-markers
            other-attributes="[[otherAttributes]]"
            input-models="[[inputModels]]"
            user-group="{{userGroup}}"
            job-creator="[[modelSpaceDetails.$key]]"
            on-data-change="addAttribute"
            on-remove-attribute="removeAttribute"
            published="[[!fullyEditable]]"
          >
          </katapult-photo-viewer>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      blankPhotoUrl: {
        type: String,
        value: ''
      },
      photoElementTypes: {
        type: Array,
        value: [
          { $key: 'chip', label: 'Chip' },
          { $key: 'point', label: 'Point (Marker)' }
        ]
      },
      markerInputModelsForDropDown: {
        type: Array,
        computed: 'computeMarkerInputModelsForDropdown(inputModels.*)'
      },
      editingDisabled: {
        type: Boolean,
        value: false,
        notify: true
      }
    };
  }

  static get observers() {
    return [`initialPhotoElementSetup(_itemData.$key)`];
  }

  ready() {
    super.ready();
  }

  constructor() {
    super();

    // setup default values
    this.blankPhotoUrl = 'https://storage.googleapis.com/katapult-pro-shared-files/photos/blank_node_photo.png';
    this.setDefaultPhotoElementProperties();
  }

  labelChanged(label) {
    this.set('_itemData.name', label);
    this.setupPhotoData();
  }

  isChip(elementType) {
    return elementType === 'chip';
  }

  updateEditabilityFlags() {
    // set the editability of the item
    let editability = this.get('_itemData.editability');
    this.fullyEditable = editability == null || editability == 'editable';
    // disable the naming of the item if it is not fully editable
    this.set('editingDisabled', !this.fullyEditable);
  }

  setDefaultPhotoElementProperties() {
    this.elementType = null;
    this.photoElementColor = '#003e51'; // dark katapult blue
    this.photoElementTextColor = 'white';
    this.allowedChildrenForPhotoElement = {};
    this.photoElementHelpText = {};
  }

  initialPhotoElementSetup() {
    if (!this._itemData) return;
    // reset to the default properties
    this.setDefaultPhotoElementProperties();
    // set the editability of the item
    this.updateEditabilityFlags();

    // setup all proper data
    this.setupElementType();
    this.setupColor();
    this.setupTextColor();
    this.setupAllowedChildren();
    this.setupHelpText();

    // update the item data
    this.updateItemData();
  }

  /**
   * Setups up the element type when the page is first loaded
   */
  setupElementType() {
    // first check the "element_type" property
    if (this._itemData.element_type) this.set(`elementType`, this._itemData.element_type);
    else {
      // default to using the pixel selection
      const pixelSelection = this._itemData._attributes?.pixel_selection;
      const elementType = pixelSelection ? 'point' : 'chip';
      this.set(`elementType`, elementType);
    }
  }

  /**
   * Setup the color for the photo element
   */
  setupColor() {
    if (this.elementType === 'chip') {
      const color = this._itemData._color;
      const textColor = this._itemData._text_color;
      if (color) this.set('photoElementColor', color);
      if (textColor) this.set('photoElementTextColor', textColor);
    } else {
      const color = Path.get(this._itemData, '_attributes.pixel_selection._color');
      if (color) this.set('photoElementColor', color);
    }
  }

  /**
   * Setup the initial text color for the chip element
   */
  setupTextColor() {
    if (this.elementType === 'chip') {
      const textColor = this._itemData._text_color;
      if (textColor) this.set('photoElementTextColor', textColor);
    }
  }

  setupAllowedChildren() {
    if (this._itemData.allowed_children) {
      const allowedChildrenForPhotoElement = {};
      this._itemData.allowed_children.forEach((child, index) => {
        const paddedIndex = index.toString().padStart(3, '0');
        allowedChildrenForPhotoElement[`-k${paddedIndex}`] = child;
      });
      this.set('allowedChildrenForPhotoElement', allowedChildrenForPhotoElement);
    }
  }

  setupHelpText() {
    if (this.elementType === 'chip') this.set('photoElementHelpText', this._itemData._help_text ?? '');
    else {
      const helpText = Path.get(this._itemData, '_attributes.pixel_selection._help_text');
      this.set('photoElementHelpText', helpText ?? '');
    }
  }

  computeMarkerInputModelsForDropdown() {
    if (!this.inputModels || !this._itemData) return [];
    // setup an array to hold the marker input models
    const inputModelsForDropDown = [];
    Object.entries(this.inputModels).forEach(([inputModelKey, inputModel]) => {
      // don't allow the current input model to be added to the list
      if (inputModelKey == this._itemData.$key) return;
      // make sure the input model is an object
      if (typeof inputModel !== 'object') inputModel = {};
      // determine if the current input model is a marker
      let elementType = inputModel.element_type;
      if (!elementType) elementType = inputModel._attributes?.pixel_selection ? 'point' : 'chip';
      // only add the input model if it exists and is a marker
      if (elementType == null || elementType !== 'point') return;
      // Add a label and key so that it will show up properly in the dropdown
      inputModel.$label = inputModel.name ?? CamelCase(inputModelKey);
      inputModel.$key = inputModelKey;
      // Push it to the list of input models for the drop down
      inputModelsForDropDown.push(inputModel);
    });
    return inputModelsForDropDown;
  }

  updateItemData() {
    if (!this._itemData || !this.elementType) return;
    // set the element type
    this.set('_itemData.element_type', this.elementType);
    // set properties based on the element type
    if (this.elementType == 'chip') {
      // cleanup the pixel selection and allowed children attributes
      if (this._itemData._attributes?.pixel_selection) delete this._itemData._attributes.pixel_selection;
      if (this._itemData.allowed_children) delete this._itemData.allowed_children;
      // set the color for the chip element
      this.set('_itemData._color', this.photoElementColor);
      this.set('_itemData._text_color', this.photoElementTextColor);
      // set the help text
      this.set('_itemData._help_text', this.photoElementHelpText);
    } else {
      // cleanup chip attributes
      if (this._itemData._color) delete this._itemData._color;
      if (this._itemData._text_color) delete this._itemData._text_color;
      if (this._itemData._help_text) delete this._itemData._help_text;

      // set the allowed children on the item data
      const allowedChildren = Object.values(this.allowedChildrenForPhotoElement ?? {}).filter((child) => child);
      this.set('_itemData.allowed_children', allowedChildren);
      // set marker specific attributes
      Path.set(this._itemData, '_attributes.pixel_selection._draw', 'point');
      Path.set(this._itemData, '_attributes.pixel_selection._measured_height', 'feet-inches');
      // set the color for the point element
      Path.set(this._itemData, '_attributes.pixel_selection._color', this.photoElementColor);
      // set the help text
      Path.set(this._itemData, '_attributes.pixel_selection._help_text', this.photoElementHelpText);
      // notify the pixel selection changes so that the change will be seen by the DOM
      this.notifyPath('_itemData._attributes.pixel_selection');
    }
    // setup the photo data for the viewer
    this.setupPhotoData();
  }

  multiSelectChanged(e) {
    // get the value from the event data
    const newValue = e.detail.value;
    if (newValue == null) return;
    // If we are adding an item, then the value is the key that we should add
    if (typeof newValue !== 'object') {
      const index = Object.keys(this.allowedChildrenForPhotoElement ?? {}).length - 1;
      const paddedIndex = index.toString().padStart(3, '0');
      this.set(`allowedChildrenForPhotoElement.-k${paddedIndex}`, newValue);
    }
    // if we are removing an item, the value is the key that we should remove
    else this.set('allowedChildrenForPhotoElement', newValue);
    // update the item data
    this.updateItemData();
  }

  photoElementChanged(e) {
    // get the property that was changed
    const property = e.currentTarget?.dataset?.property;
    const newValue = e.detail.value;
    if (!property) return;
    // get and set data from the event
    this.set(property, newValue);

    // update the item data
    this.updateItemData();
  }

  setupPhotoData() {
    // add the current photo element's item data to the list of input models so the photo viewer knows how to display it
    this.set(`inputModels.${this._itemData.$key}`, this._itemData);

    // get and set the photo data for the viewer
    const photoData = this.getPhotoData();
    this.set('photoData', photoData);
  }

  getPhotoData() {
    // get the proper data from _itemData
    const itemDataKey = this._itemData.$key;
    const itemDataAttributes = Path.copy(this._itemData._attributes ?? {});
    // remove pixel selection because we are trying to get attribute that can be added through the annotation editor
    delete itemDataAttributes.pixel_selection;
    // get the attribute values out of the attribute data
    const itemAttributeValues = {};
    Object.entries(itemDataAttributes).forEach(([attributeKey, attributeData]) => {
      itemAttributeValues[attributeKey] = attributeData.value;
    });
    // create a photo data object
    const photoData = {
      photofirst_data: {
        [itemDataKey]: {
          'i-0': {
            ...itemAttributeValues
          }
        }
      },
      url_large: this.blankPhotoUrl
    };
    // add a pixel selection if the element type is a point
    if (this.elementType === 'point')
      Path.set(photoData, `photofirst_data.${itemDataKey}.i-0.pixel_selection`, [{ percentX: 50, percentY: 50 }]);
    // return the photo data
    return photoData;
  }

  buildAttributeModelToAdd(attributeKey) {
    const model = this.otherAttributes[attributeKey];
    if (!model) return;
    const modelCopy = Path.copy(model);
    // setup an attribute object to build
    const attributeObject = {};
    // add all properties that are needed
    const attributesNeeded = ['gui_element', 'prevent_carry', 'priority', 'placeholder'];
    attributesNeeded.forEach((attribute) => {
      if (modelCopy[attribute]) attributeObject[attribute] = modelCopy[attribute];
    });
    // choose the proper picklist if the attribute has picklists
    if (modelCopy.picklists) {
      // TODO (09/26/2024): There is a story to do a better job at choosing the proper picklist in the works.  This is mostly temporary!
      // Choose the default picklist if it exists
      let picklist = modelCopy.picklists.default;
      // if a default picklist doesn't exist, just choose the first one
      if (!picklist) picklist = Object.values(modelCopy.picklists)[0];
      // add the picklist to the attribute object
      attributeObject.picklist = picklist;
    }
    return attributeObject;
  }

  addAttribute(e) {
    const attributeKey = e.detail.attribute_name;
    // if the attribute name is not valid, skip execution (i-0 means that the user is trying to delete the marker and pixel selection means the user is trying to move the marker. These actions should not be allowed)
    if (!attributeKey || attributeKey == 'i-0' || attributeKey == 'pixel_selection') return;
    // get the attribute value
    const attributeValue = e.detail.value;

    // build an attribute object to add if there isn't one
    if (!this._itemData?._attributes) this.set('_itemData._attributes', {});
    let attributeObject = this._itemData._attributes[attributeKey];
    if (attributeObject == null) {
      attributeObject = this.buildAttributeModelToAdd(attributeKey);
      if (attributeObject == null) return;
    }

    // add the attribute value to the attribute object
    attributeObject.value = attributeValue;

    // set the attribute object in the attribute of the current item data
    this._itemData._attributes[attributeKey] = attributeObject;
    // notify the path so that the change will be seen by the DOM
    this.notifyPath(`_itemData._attributes.${attributeKey}`);

    // update the photo data because the attributes changed
    this.setupPhotoData();
  }

  removeAttribute(e) {
    // verify that the attribute name is valid
    const attribute_name = e.detail.attribute_name;
    if (!attribute_name) return;
    // remove the attribute from the item data
    delete this._itemData._attributes[attribute_name];
    this.notifyPath(`_itemData._attributes`);
    // update the photo data because the attributes changed
    this.setupPhotoData();
  }

  inputModelsLabelFunction(inputModel) {
    return inputModel?.name || CamelCase(inputModel?.$key);
  }

  tagSelectorChangeHandler(e) {
    const tags = e.target.tags;
    this.set('_itemData.tags', tags);
  }
}

customElements.define('katapult-photo-element-editor', KatapultPhotoElementEditor);
